<template>
  <nav class="navbar">
    <div class="navbar-section navbar-left">
      <button class="refresh-button" @click="refreshPage" title="Rafraîchir la page">
        <img src="@/assets/logow.png" alt="Logo" class="navbar-logo" />
      </button>
    </div>
    
    
    <div class="navbar-section navbar-right">
      <button class="logout-button" @click="handleLogout" title="Se déconnecter">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16 17L21 12L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M21 12H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="logout-text">Déconnexion</span>
      </button>
    </div>
  </nav>
</template>

<script setup>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import authService from '@/services/authService'

defineComponent({ name: 'AppNavbar' })

const router = useRouter()


// Fonction pour rafraîchir la page
const refreshPage = () => {
  window.location.reload()
}

// Fonction pour gérer la déconnexion
const handleLogout = async () => {
  try {
    await authService.logout()
    // Rediriger vers la page de connexion
    router.push({ name: 'Login' })
  } catch (error) {
    console.error('Erreur lors de la déconnexion:', error)
    // Même en cas d'erreur, on redirige vers login
    router.push({ name: 'Login' })
  }
}
</script>

<style scoped>
/* Main navbar container with CSS Grid for precise control */
.navbar {
  height: 70px;
  width: 100vw;
  background: #1a2a4f;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding: 0 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  overflow: hidden;
}

/* Navbar sections */
.navbar-section {
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 0; /* Allow shrinking */
}

/* Left section - Logo */
.navbar-left {
  justify-content: flex-start;
}

.refresh-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
}

.refresh-button:hover {
  transform: scale(1.05);
}

.navbar-logo {
  height: 40px;
  width: auto;
  max-width: 150px;
}

/* Center section - User info */
.navbar-center {
  justify-content: center;
  overflow: hidden;
  padding: 0 10px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  overflow: hidden;
}

.navbar-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.user-name {
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.user-email {
  color: #bfc7d5;
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

/* Right section - Logout */
.navbar-right {
  justify-content: flex-end;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 5px;
  background: rgba(203, 184, 124, 0.1);
  border: 1px solid #cbb87c;
  color: #cbb87c;
  padding: 6px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}

.logout-button:hover {
  background: #cbb87c;
  color: #1a2a4f;
  transform: translateY(-1px);
}

.logout-button svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.logout-text {
  font-family: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Responsive breakpoints */
@media (max-width: 1200px) {
  .navbar {
    grid-template-columns: auto 1fr auto;
  }
  
  .user-name {
    font-size: 0.95rem;
  }
}

@media (max-width: 1024px) {
  .navbar {
    grid-template-columns: auto 1fr auto;
    padding: 0 12px;
  }
  
  .navbar-logo {
    height: 35px;
  }
  
  .navbar-avatar {
    width: 38px;
    height: 38px;
  }
  
  .user-name {
    font-size: 0.9rem;
  }
  
  .user-email {
    font-size: 0.75rem;
  }
  
  .logout-button {
    padding: 5px 8px;
    font-size: 0.75rem;
  }
}

@media (max-width: 768px) {
  .navbar {
    grid-template-columns: auto 1fr auto;
    padding: 0 10px;
  }
  
  .navbar-logo {
    height: 32px;
  }
  
  .navbar-avatar {
    width: 35px;
    height: 35px;
  }
  
  .user-details {
    display: none;
  }
  
  .logout-text {
    display: none;
  }
  
  .logout-button {
    padding: 6px;
    min-width: auto;
    gap: 0;
  }
}

@media (max-width: 480px) {
  .navbar {
    grid-template-columns: auto 1fr auto;
    padding: 0 8px;
  }
  
  .navbar-logo {
    height: 28px;
  }
  
  .navbar-avatar {
    width: 32px;
    height: 32px;
  }
  
  .logout-button {
    padding: 4px;
  }
  
  .logout-button svg {
    width: 14px;
    height: 14px;
  }
}
</style>